export default __webpack_public_path__ + "static/media/excelattendance_icon.2db25ba2.svg";